module.exports = __webpack_public_path__ + "static/media/cloud.d069a276.png";